<div
  class="modal fade"
  id="modalIntencaoSaida"
  tabindex="-1"
  aria-labelledby="modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-custom">
      <div class="modal-body d-flex flex-column flex-md-row align-items-center">
        <div class="modal-text text-center">
          <h3 class="modal-title">Gostou do que viu?</h3>
          <h5>Você chegou ao limite de visualizações desta prévia.</h5>

          <p class="mb-3">
            Fale com a gente para descobrir como ter <br />acesso completo à
            <strong>Rede de Obras</strong>
            e encontrar<br />
            ainda mais oportunidades para sua empresa.
          </p>

          <div class="btn-link">
            <a
              target="_blank"  rel="noopener noreferrer"
              href="https://rededeobras.construmarket.com.br/fichas-de-prospeccao?utm_source=admin-rdo&utm_medium=teste&utm_campaign=teste_gratuito"
              >Falar com a equipe</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
